if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.ensureRequiredUploadFallback();
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.form.querySelectorAll('[data-required-file], [data-required-property]').forEach((field) => {
        field.addEventListener(field.type === 'file' ? 'change' : 'input', () => {
          this.clearRequiredFieldError(field);
        });
      });
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    ensureRequiredUploadFallback() {
      const requiredUploadHandle = '/products/1pc-custom-9-inch-dtf-transfer-23x23cm';
      const requiredUploadVariantIds = new Set(['52281229738286', '52281229771054']);
      const variantInput = this.form.querySelector('[name=id]');
      const isRequiredUploadProduct =
        window.location.pathname === requiredUploadHandle ||
        (variantInput && requiredUploadVariantIds.has(String(variantInput.value)));

      if (!isRequiredUploadProduct) return;

      this.querySelectorAll('.shopify-payment-button').forEach((button) => button.remove());
      if (this.form.querySelector('input[type="file"][name="properties[Upload]"]')) return;

      const buttons = this.form.querySelector('.product-form__buttons');
      if (!buttons) return;

      const group = document.createElement('div');
      group.className = 'product-form__special-upload';
      group.dataset.specialRequiredGroup = '';
      group.dataset.arteefyRequiredUploadFallback = 'true';
      group.style.cssText =
        'display:block;width:100%;max-width:44rem;box-sizing:border-box;border:1px solid rgba(var(--color-foreground),.18);border-radius:.4rem;background:rgb(var(--color-background));padding:1.6rem;margin:1.6rem 0;';
      group.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:.8rem">
          <label class="form__label" for="RequiredArtwork-${this.id || 'product'}" style="margin:0;font-size:1.5rem;font-weight:700">Upload artwork</label>
          <span style="border-radius:999px;background:rgba(var(--color-foreground),.08);padding:.55rem .8rem;font-size:1.1rem;font-weight:700;text-transform:uppercase">Required</span>
        </div>
        <p style="margin:0 0 1rem;color:rgba(var(--color-foreground),.72);font-size:1.25rem">Upload the design file you want us to print.</p>
        <input
          id="RequiredArtwork-${this.id || 'product'}"
          type="file"
          name="properties[Upload]"
          accept="image/jpg,image/jpeg,image/JPG,image/JPEG,image/webp,image/WEBP,image/png,.HEIC,image/PNG,image/svg+xml"
          required
          data-required-file
          style="display:block;width:100%;min-height:4.4rem;border:1px solid rgba(var(--color-foreground),.28);border-radius:.3rem;padding:.8rem"
        >
        <p class="product-form__special-field-error" data-special-field-error hidden style="margin:.8rem 0 0;color:#c9002b;font-size:1.2rem"></p>
        <p class="caption" style="margin-top:.9rem">Accepted: PNG, JPG, JPEG, WEBP, HEIC, or SVG.</p>
      `;
      buttons.before(group);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.clearRequiredFieldErrors();

      const requiredFile = this.form.querySelector('[data-required-file]');
      if (requiredFile && (!requiredFile.files || requiredFile.files.length === 0)) {
        const message = 'Please upload your artwork file before adding this item to cart.';
        this.handleErrorMessage(message);
        this.setRequiredFieldError(requiredFile, message);
        requiredFile.focus();
        return;
      }

      const requiredProperty = this.form.querySelector('[data-required-property]');
      if (requiredProperty && requiredProperty.value.trim() === '') {
        const message = 'Please enter your special size request before adding this item to cart.';
        this.handleErrorMessage(message);
        this.setRequiredFieldError(requiredProperty, message);
        requiredProperty.focus();
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    clearRequiredFieldErrors() {
      this.form.querySelectorAll('[data-required-file], [data-required-property]').forEach((field) => {
        this.clearRequiredFieldError(field);
      });
    }

    clearRequiredFieldError(field) {
      const group = field.closest('[data-special-required-group]');
      if (!group) return;

      group.classList.remove('is-error');
      field.removeAttribute('aria-invalid');

      const message = group.querySelector('[data-special-field-error]');
      if (message) {
        message.textContent = '';
        message.hidden = true;
      }
    }

    setRequiredFieldError(field, errorMessage) {
      const group = field.closest('[data-special-required-group]');
      if (!group) return;

      group.classList.add('is-error');
      field.setAttribute('aria-invalid', true);

      const message = group.querySelector('[data-special-field-error]');
      if (message) {
        message.textContent = errorMessage;
        message.hidden = false;
      }
    }
  });
}
